export function normalizeOtpPending(data) {
  if (!data) return []
  if (Array.isArray(data.pending) && data.pending.length) {
    return data.pending
  }
  if (data.otp_required && data.shipment_id) {
    return [{
      shipment_id: data.shipment_id,
      masked_phones: data.masked_phones || [],
      expires_in_seconds: data.expires_in_seconds,
      receiver_name: data.receiver_name,
      resend_available_in_seconds: data.resend_available_in_seconds,
    }]
  }
  return []
}

export function isOtpRequiredResponse(data) {
  return Boolean(data?.otp_required && normalizeOtpPending(data).length)
}
